import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services';
import { ModalService } from 'src/app/shared/components';
import { PushNotificationService } from '../../services/pwa/push-notification.service';

@Component({
    selector: 'lc-header',
    templateUrl: './header.html',
    animations: [toggleAnimation],
    // standalone: true,
    // imports: [NotificationsComponent],
})
export class HeaderComponent implements OnInit, OnDestroy {
    private readonly pushNotificationService = inject(PushNotificationService);

    store: any;
    search = false;

    // Estado da permissão de notificações
    readonly hasNotificationPermission = signal<boolean>(false);
    readonly isNotificationSupported = signal<boolean>(false);
    messages = [
        {
            id: 1,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-info-light dark:bg-info text-info dark:text-info-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`
            ),
            title: 'Recurso em Desenvolvimento',
            // message: 'Mensagens são exemplos - Sistema de alertas em desenvolvimento',
            message: 'Sistema de alertas',
            time: 'Agora',
        },
        // {
        //     id: 2,
        //     image: this.sanitizer.bypassSecurityTrustHtml(
        //         `<span class="grid place-content-center w-9 h-9 rounded-full bg-success-light dark:bg-success text-success dark:text-success-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></span>`
        //     ),
        //     title: 'Sistema Operacional',
        //     message: 'Todos os 12 postos estão online e funcionando',
        //     time: '1hr',
        // },
        // {
        //     id: 3,
        //     image: this.sanitizer.bypassSecurityTrustHtml(
        //         `<span class="grid place-content-center w-9 h-9 rounded-full bg-warning-light dark:bg-warning text-warning dark:text-warning-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg></span>`
        //     ),
        //     title: 'Manutenção Necessária',
        //     message: 'Câmera do Portão Principal precisa de limpeza',
        //     time: '2hr',
        // },
        // {
        //     id: 4,
        //     image: this.sanitizer.bypassSecurityTrustHtml(
        //         `<span class="grid place-content-center w-9 h-9 rounded-full bg-danger-light dark:bg-danger text-danger dark:text-danger-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>`
        //     ),
        //     title: 'Falha Crítica!',
        //     message: 'Sistema de alarme do Setor A está offline',
        //     time: '5min',
        // },
        // {
        //     id: 5,
        //     image: this.sanitizer.bypassSecurityTrustHtml(
        //         `<span class="grid place-content-center w-9 h-9 rounded-full bg-info-light dark:bg-info text-info dark:text-info-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`
        //     ),
        //     title: 'Atualização Programada',
        //     message: 'Sistema será atualizado hoje às 02:00 - Downtime: 15min',
        //     time: '6hr',
        // },
    ];

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private language: LanguageService,
        private sanitizer: DomSanitizer,
        private modalService: ModalService
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select(d => d.index)
            .subscribe(d => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.setActiveDropdown();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
            }
        });
        this.verificarEstadoNotificacoes();

        // Verificar periodicamente (caso mude)
        this.intervalCheck = setInterval(() => {
            this.verificarEstadoNotificacoes();
        }, 5000); // Verificar a cada 5 segundos
    }

    ngOnDestroy() {
        if (this.intervalCheck) {
            clearInterval(this.intervalCheck);
        }
    }

    private intervalCheck: any;

    /**
     * Verifica o estado atual das notificações
     */
    private async verificarEstadoNotificacoes(): Promise<void> {
        const isSupported = this.pushNotificationService.isSupported();
        this.isNotificationSupported.set(isSupported);

        if (isSupported) {
            const hasPermission = await this.pushNotificationService.hasPermission();
            this.hasNotificationPermission.set(hasPermission);
        }
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    removeMessage(value: number) {
        this.messages = this.messages.filter(d => d.id !== value);
    }

    changeLanguage(item: any) {
        this.translate.use(item.code);
        this.language.toggleLanguage(item);
        if (this.store.locale?.toLowerCase() === 'ae') {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
        } else {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
        }
        window.location.reload();
    }

    async reloadApplication(): Promise<void> {
        const result = await this.modalService.open({
            header: 'Recarregar Aplicação',
            body: `
                <div class="text-center">
                    <p class="text-lg font-semibold text-gray-800 mb-2">
                        Tem certeza que deseja recarregar a aplicação?
                    </p>
                    <p class="text-sm text-gray-600 mb-4">
                        Esta ação irá recarregar completamente a página e você perderá qualquer dado não salvo.
                        <br><strong>Use apenas em caso de atualizações ou problemas no sistema.</strong>
                    </p>
                </div>
            `,
            confirmText: 'Sim, Recarregar',
            cancelText: 'Cancelar',
            confirmColor: 'danger',
            cancelColor: 'danger',
        });

        if (result === 'confirm') {
            window.location.reload();
        }
    }

    /**
     * Ativa/Atualiza push notifications
     * SEMPRE cria/atualiza subscription no backend (resolve problema de subscriptions antigas)
     */
    async ativarNotificacoes(): Promise<void> {
        console.log('[Header] 🔔 ativarNotificacoes() chamado!');

        try {
            const jaTemPermissao = typeof Notification !== 'undefined' && Notification.permission === 'granted';

            if (!jaTemPermissao) {
                // Solicitar permissão
                console.log('[Header] 📋 Solicitando permissão...');
                const permission = await this.pushNotificationService.solicitarPermissao();
                console.log('[Header] 🔐 Permissão recebida:', permission);

                if (permission !== 'granted') {
                    this.modalService.open({
                        header: 'Permissão Negada',
                        body: `
                            <div class="text-center">
                                <p class="text-lg font-semibold text-red-600 mb-2">
                                    ❌ Permissão negada
                                </p>
                                <p class="text-sm text-gray-600">
                                    Você precisa permitir notificações nas configurações do navegador.
                                </p>
                            </div>
                        `,
                        confirmText: 'OK',
                    });
                    return;
                }
            }

            // SEMPRE inicializa/atualiza subscription (mesmo se já tiver)
            console.log('[Header] 🔄 Criando/Atualizando subscription no backend...');
            const sucesso = await this.pushNotificationService.inicializar();
            console.log('[Header] 📊 Resultado:', sucesso);

            if (sucesso) {
                // Atualizar estado
                this.hasNotificationPermission.set(true);

                // Mostrar feedback
                this.modalService.open({
                    header: jaTemPermissao ? 'Subscription Atualizada' : 'Notificações Ativadas',
                    body: `
                        <div class="text-center">
                            <p class="text-lg font-semibold text-green-600 mb-2">
                                ✅ ${jaTemPermissao ? 'Subscription atualizada' : 'Notificações ativadas'} com sucesso!
                            </p>
                            <p class="text-sm text-gray-600">
                                ${jaTemPermissao ?
                            'Sua inscrição foi renovada no servidor.' :
                            'Você receberá notificações mesmo com o app fechado.'}
                            </p>
                        </div>
                    `,
                    confirmText: 'OK',
                });
            } else {
                this.modalService.open({
                    header: 'Erro',
                    body: `
                        <div class="text-center">
                            <p class="text-lg font-semibold text-red-600 mb-2">
                                ❌ Erro ao processar subscription
                            </p>
                            <p class="text-sm text-gray-600">
                                Tente novamente ou verifique o console.
                            </p>
                        </div>
                    `,
                    confirmText: 'OK',
                });
            }
        } catch (error: any) {
            console.error('[Header] Erro ao ativar notificações:', error);
            this.modalService.open({
                header: 'Erro',
                body: `
                    <div class="text-center">
                        <p class="text-lg font-semibold text-red-600 mb-2">
                            ❌ Erro ao ativar notificações
                        </p>
                        <p class="text-sm text-gray-600">
                            ${error instanceof Error ? error.message : 'Erro desconhecido'}
                        </p>
                    </div>
                `,
                confirmText: 'OK',
            });
        }
    }
}
